module.exports = {
    

    /* API KEYS */
    /* AUTH COLLECTION */
    endpoint_auth_signin: `${process.env.REACT_APP_API_URL_STAGING}/api/admin/login`,
    endpoint_google_map: process.env.REACT_APP_API_KEY_GOOGLE_MAPS,
    /* DROP POINT COLLECTION */
    endpoint_get_droPoints : `${process.env.REACT_APP_API_URL_STAGING}/api/point/dashboard/points` ,
    endpoint_post_dropPonts :`${process.env.REACT_APP_API_URL_STAGING}/api/point/dashboard/store`,
    endpoint_patch_dropPoints : `${process.env.REACT_APP_API_URL_STAGING}/api/point/dashboard/update/`,
    endpoint_delete_dropPoints : `${process.env.REACT_APP_API_URL_STAGING}/api/point/dashboard/delete/` ,

    /* BOOKING COLLECTION */
    endpoint_get_booking :`${process.env.REACT_APP_API_URL_STAGING}/api/booking/dashboard/get-bookings`,
    endpoint_get_cancellation_booking : `${process.env.REACT_APP_API_URL_STAGING}/api/booking/dashboard/get-cancellation-reasons` ,
    endpoint_patch_cancellation_booking : `${process.env.REACT_APP_API_URL_STAGING}/api/booking/dashboard/update-cancellation-reason/`,
    endpoint_post_cancellation_booking :`${process.env.REACT_APP_API_URL_STAGING}/api/booking/dashboard/add-cancellation-reason`,
    endpoint_delete_cancellation_booking : `${process.env.REACT_APP_API_URL_STAGING}/api/booking/dashboard/delete-cancellation-reason/`,
    endpoint_get_bookings_requests : `${process.env.REACT_APP_API_URL_STAGING}/api/request/dashboard/get-booking-requests`,
    endpoint_patch_booking_request:`${process.env.REACT_APP_API_URL_STAGING}/api/request/dashboard/update/`,

    /* DRIVER COLLECTION */
    endpoint_get_driver_approved : `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/get-drivers-per-step/approved` ,
    endpoint_get_driver_subscribed : `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/get-drivers-per-step/subscribed` ,
    endpoint_get_driver_banned : `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/get-drivers-per-step/banned` ,
    endpoint_admit_driver : `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/validate-account/`,
    endpoint_approve_driver : `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/approve/`,
    endpoint_ban_driver : `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/ban/` ,
    endpoint_get_driver_faq :`${process.env.REACT_APP_API_URL_STAGING}/api/faq/dashboard/driverFAQsAdmin` ,
    endpoint_post_driver_faq : `${process.env.REACT_APP_API_URL_STAGING}/api/faq/dashboard/store` ,
    endpoint_patch_driver_faq : `${process.env.REACT_APP_API_URL_STAGING}/api/faq/dashboard/update/`,
    endpoint_delete_driver_faq :`${process.env.REACT_APP_API_URL_STAGING}/api/faq/dashboard/delete/` ,
    endpoint_patch_driver_profile :`${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/profile-update/` ,
    endpoint_patch_driver_profile_picture : `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/profile-image-update/`,
    endpoint_create_driver_vehicule : `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/create-vehicule`,
    endpoint_patch_driver_vehicule : `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/update-vehicule/` ,
    endpoint_delete_driver_vehicule :`${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/delete-vehicule/` ,
    endpoint_patch_driver_line : `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/update-line/` ,
    endpoint_patch_driver_zone : `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/update-zones/` ,


    /* RIDER COLLECTION */
    endpoint_get_rider :`${process.env.REACT_APP_API_URL_STAGING}/api/rider/dashboard/get-all-riders` ,
    endpoint_get_rider_faq : `${process.env.REACT_APP_API_URL_STAGING}/api/faq/dashboard/riderFAQsAdmin`,
    endpoint_post_rider_faq :`${process.env.REACT_APP_API_URL_STAGING}/api/faq/dashboard/store` ,
    endpoint_patch_rider_faq : `${process.env.REACT_APP_API_URL_STAGING}/api/faq/dashboard/update/` ,
    endpoint_delete_rider_faq : `${process.env.REACT_APP_API_URL_STAGING}/api/faq/dashboard/delete/` ,

    /* TIMESLOT COLLECTION */
    endpoint_get_timeslot : `${process.env.REACT_APP_API_URL_STAGING}/api/timeslot/timeslots`,
    endpoint_post_timeslot : `${process.env.REACT_APP_API_URL_STAGING}/api/timeslot/store`,
    endpoint_delete_timeslot : `${process.env.REACT_APP_API_URL_STAGING}/api/timeslot/delete/`,
    endpoint_patch_timeslot : `${process.env.REACT_APP_API_URL_STAGING}/api/timeslot/update/`,

    /* TRIP COLLECTION */
    endpoint_get_trip : `${process.env.REACT_APP_API_URL_STAGING}/api/trip/dashboard/get-trips`,
    endpoint_cancel_trip : `${process.env.REACT_APP_API_URL_STAGING}/api/trip/dashboard/cancel-trip/`,
    endpoint_get_cancellation_trip : `${process.env.REACT_APP_API_URL_STAGING}/api/trip/dashboard/get-cancellation-reasons` ,
    endpoint_patch_cancellation_trip : `${process.env.REACT_APP_API_URL_STAGING}/api/trip/dashboard/add-cancellation-reason`,
    endpoint_post_cancellation_trip : `${process.env.REACT_APP_API_URL_STAGING}/api/trip/dashboard/update-cancellation-reason/`,
    endpoint_delete_cancellation_trip : `${process.env.REACT_APP_API_URL_STAGING}/api/trip/dashboard/delete-cancellation-reason/`,

    /* LINE COLLECTION */
    endpoint_get_line :`${process.env.REACT_APP_API_URL_STAGING}/api/line/dashboard/lines`,
    endpoint_post_line : `${process.env.REACT_APP_API_URL_STAGING}/api/line/dashboard/store`,
    endpoint_delete_line : `${process.env.REACT_APP_API_URL_STAGING}/api/line/dashboard/delete/`,
    endpoint_patch_line : `${process.env.REACT_APP_API_URL_STAGING}/api/line/dashboard/update/`,
    endpoint_get_lines_requests : `${process.env.REACT_APP_API_URL_STAGING}/api/request/dashboard/get-line-requests`,

    /* PAYEMENT COLLECTION */
    endpoint_get_payement : `${process.env.REACT_APP_API_URL_STAGING}/api/payment/dashboard/get-payments-all`,
    endpoint_patch_payement : `${process.env.REACT_APP_API_URL_STAGING}/api/payment/dashboard/update-payment/`,

    /* COUPON COLLECTION */
    endpoint_get_coupon : `${process.env.REACT_APP_API_URL_STAGING}/api/coupon/dashboard/all` ,
    endpoint_post_coupon : `${process.env.REACT_APP_API_URL_STAGING}/api/coupon/dashboard/store` ,
    endpoint_patch_coupon : `${process.env.REACT_APP_API_URL_STAGING}/api/coupon/dashboard/update/` ,
    endpoint_delete_coupon : `${process.env.REACT_APP_API_URL_STAGING}/api/coupon/dashboard/delete/` ,


    /* NOT TESTED ENDPOINT  */
    /* ADMIN COLLECTION */
    endpoint_get_dashboard_users : `${process.env.REACT_APP_API_URL_STAGING}/api/admin/all` ,
    endpoint_post_new_user_dashboard : `${process.env.REACT_APP_API_URL_STAGING}/api/admin/store` ,
    endpoint_add_admin_authorities : `${process.env.REACT_APP_API_URL_STAGING}/api/admin/add-authority`,
    endpoint_post_new_authority_user_dashboard : `${process.env.REACT_APP_API_URL_STAGING}/api/admin/add-authority` ,
    endpoint_patch_activate_deactivate_admin_account :`${process.env.REACT_APP_API_URL_STAGING}/api/admin/activate-account`,
    endpoint_patch_dashboard_user_authorities : `${process.env.REACT_APP_API_URL_STAGING}/api/admin/update-authority` ,

    /* TO APPROV A DRIVER FROM A FORM */
    endpoint_patch_approv_driver: `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/approve-account`,

    /* GET STATS IN THE LANDING PAGE*/
    endpoint_get_stats_landing: `${process.env.REACT_APP_API_URL_STAGING}/test`,

    /*GET DRIVER HISTORY*/
    endpoint_get_driver_trips_confirmed: `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/get-driver-history/`,
    endpoint_get_driver_trips_in_progress: `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/get-driver-history/`,
    endpoint_get_driver_trips_declined: `${process.env.REACT_APP_API_URL_STAGING}/api/driver/dashboard/get-driver-history/`,

    // OPERATIONAL DRIVERS
    endpoint_get_operational_drivers: `${process.env.REACT_APP_API_URL_STAGING}/test`,
    endpoint_post_operational_drivers: `${process.env.REACT_APP_API_URL_STAGING}/test`,

    //SMS GATEWAY
    endpoint_get_sms_gateway: `${process.env.REACT_APP_API_URL_STAGING}/test`,
    endpoint_post_sms_gateway: `${process.env.REACT_APP_API_URL_STAGING}/test`

};